// Page Visibility API (~2011). Si el navegador no la tiene, tratamos la
// pestaña como visible y el poll sigue igual que antes.
function hiddenProp() {
  if (typeof document === "undefined") return null
  if (typeof document.hidden === "boolean") return "hidden"
  if (typeof document.webkitHidden === "boolean") return "webkitHidden"
  return null
}

function visibilityEvent() {
  const prop = hiddenProp()
  if (prop === "hidden") return "visibilitychange"
  if (prop === "webkitHidden") return "webkitvisibilitychange"
  return null
}

export function isPageVisible() {
  const prop = hiddenProp()
  if (!prop) return true
  return !document[prop]
}

export function onPageVisibilityChange(callback) {
  const event = visibilityEvent()
  if (!event) return () => {}
  document.addEventListener(event, callback)
  return () => document.removeEventListener(event, callback)
}
